import { z } from 'zod';

/////////////////////////////////////////
// PERMITS CHARGES SCHEMA
/////////////////////////////////////////

export const PermitsChargesSchema = z.object({
  id: z.bigint(),
  permit_id: z.number().int().nullable(),
  fee_schedule_id: z.number().int().nullable(),
  amount: z.number().int().nullable(),
  details: z.string().nullable(),
  paid: z.boolean().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  pending: z.boolean().nullable(),
  transaction_id: z.string().nullable(),
  payment_method: z.string().nullable(),
  payment_description: z.string().nullable(),
  active: z.boolean().nullable(),
  fee_id: z.bigint().nullable(),
  permits_extension_id: z.bigint().nullable(),
  fee_item_id: z.bigint().nullable(),
  subtotal: z.boolean(),
  rowTimestamp: z.coerce.date(),
})

export type PermitsCharges = z.infer<typeof PermitsChargesSchema>

export default PermitsChargesSchema;
